<template>
    <select
    id="select-element-type"
    style="margin-left:40px;"
    @change="elementTypeQuestion($event)"
    >
      <option
        v-for="element in elementTypeData"
        :selected="element === question.element_type"
        :value="element"
        :key="element"
      >
        <p :value="element">{{ $t("question.choix." + element) }}</p>
      </option>
    </select>
</template>

<script>
import EventBus from '@/eventBus'
export default {
  name: 'ElementTypeDropdown',
  props: {
    indexSection: Number,
    indexQuestion: Number,
    questionElementType: String,
    question: Object
  },
  data () {
    return {
      elementTypeData: [
        'radio',
        'checkboxes',
        'orderedChoices',
        'select',
        'notation',
        'content'
      ]
    }
  },
  methods: {
    elementTypeQuestion (event) {
      this.question.element_type = event.target.value
      this.$store.commit('UPDATE_ELEMENT_TYPE_QUESTION', {
        type: this.indexSection ? 'section' : 'simple',
        indexSection: this.indexSection,
        indexQuestion: this.indexQuestion,
        question: this.question
      })
      EventBus.$emit('update_question')
      if (event.target.value !== 'radio' && this.indexSection >= 0) {
        this.resetOptionsQuestionsIfSections()
      }
      this.$store.commit('TEST_SAVE_QUESTION_BUTTON')
    },
    resetOptionsQuestionsIfSections () {
      /** permet de remettre les paramètres par default des propositions quand l'option 'section' est choisie */
      this.$store.commit('RESET_QUESTION_CHANGE_TYPE_OPTIONS_SECTIONS', {
        type: 'section',
        indexSection: this.indexSection,
        indexQuestion: this.indexQuestion
      })
    }
  }
}
</script>
<style scoped>
#select-element-type{
  -webkit-appearance: none;
  -moz-appearance: none;
  background: #ffffff;
  color:#aaa;
  background-image: url("data:image/svg+xml;utf8,<svg fill='black' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>");
  background-repeat: no-repeat;
  background-position-x: 100%;
  background-position-y: 50%;
  padding-right: 2rem;
  cursor:pointer;
  border:.8px solid #dddddd
}
select option{
  color: #000;
}
</style>



// WEBPACK FOOTER //
// src/components/question/components/ElementTypeDropdown.vue